import PropTypes from 'prop-types'

import AppPreview from './AppPreview'
import SmsPreview from './SmsPreview'
import EmailPreview from './EmailPreview'
import { inAppCommunication, smsCommunication } from './helpers'

const LivePreview = ({ data, buildingName }) => {
  const { subtype, questions, type, communicationType } = data
  const preparePreview = () => {
    switch (communicationType) {
      case inAppCommunication:
        return <AppPreview type={type} subtype={subtype} questions={questions} />
      case smsCommunication:
        return (
          <SmsPreview question={questions[0].title} subtype={subtype} buildingName={buildingName} />
        )
      default:
        return (
          <EmailPreview
            questions={questions}
            subtype={subtype}
            type={type}
            buildingName={buildingName}
          />
        )
    }
  }
  return <div className="live-preview">{preparePreview()}</div>
}

LivePreview.propTypes = {
  data: PropTypes.object,
  buildingName: PropTypes.string,
}

export default LivePreview
